module.exports = __webpack_public_path__ + "static/media/Pranshu Gupta.7c1ee064.jpg";